import DapGeoLocFixCallbackController from './dap-geo-loc-fix-callback.controller';
import Template from './dap-geo-loc-fix-callback.html';
export default {
	bindings: {
		resolve: '='
	},
	controller: DapGeoLocFixCallbackController,
	template: Template
};
